export { default as DatePicker } from "./datepicker";
// export { default as ModalComponent } from "./modal";
export { default as useScreenSize } from "./useScreenSize";
export { default as Pagination } from "./Pagination";
export { default as Tabs } from "./tab";
export { default as ModalComponent } from "./modal/index";
